/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IAadGenericViewProps } from './aad-generic';

export default (props: IAadGenericViewProps) => {
    const {
        aadGeneric,
        aadConainer,
        aadAPIConainer,
        heading
    } = props;

    return (
        <Module {...aadGeneric}>
            <Node {...aadConainer}>
                {heading}
                {aadAPIConainer}
            </Node>
        </Module>
    );
};
